/*
 * NOURION Panel Eintritt (panelEnter aus lib/easing.ts als
 * IntersectionObserver): Elemente mit .k-reveal bekommen einmalig
 * .k-reveal--in, sobald sie mit 80px Vorlauf ins Sichtfeld kommen.
 * Entspricht viewport { once: true, margin: '-80px' } der React Quelle.
 * Reinitialisiert sich bei shopify:section:load (Theme Editor rendert
 * Sections ohne Seiten Reload neu).
 */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var io = null;

  function beobachte(wurzel) {
    var els = (wurzel || document).querySelectorAll('.k-reveal:not(.k-reveal--in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('k-reveal--in');
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            entries[j].target.classList.add('k-reveal--in');
            io.unobserve(entries[j].target);
          }
        }
      }, { rootMargin: '-80px' });
    }

    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }

  beobachte(document);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) beobachte(e.target);
  });
})();
